import moment from "moment";
import { useEffect, useState } from "react";

export function useMomentNow(interval = 30_000) {
  const [now, setNow] = useState(moment.now());

  useEffect(() => {
    const tick = () => setNow(moment.now());

    const intervalId = setInterval(tick, interval);

    // Immediately refresh when the tab becomes visible again.
    // Handles both sleep/wake and returning from a background tab,
    // where setInterval ticks may have been throttled or suspended.
    const onVisibilityChange = () => {
      if (document.visibilityState === "visible") tick();
    };
    document.addEventListener("visibilitychange", onVisibilityChange);

    return () => {
      clearInterval(intervalId);
      document.removeEventListener(
        "visibilitychange",
        onVisibilityChange,
      );
    };
  }, [interval]);

  return now;
}
